<template lang="pug">

form.ui.error.form(v-on:submit.prevent="submit()")

    //- Navigation
    navigation(@toggle="$emit('toggle')")

    //- Headline
    //- .ui.attached.segment
    //-     h2.ui.header
    //-         i.list.ol.icon
    //-         .content Kampagne anlegen

    //- Formular
    .ui.top.attached.header Allgemeine Informationen:
    create-form(
        ref="form"
        v-model="mutable"
        v-bind:segment="'ui bottom attached segment'"
        v-bind:company-models="companyModels"
    )

    //- Actions
    action-row.ui.bottom.secondary(v-on:cancel="cancel()")

</template>

<script>
    import * as R from 'ramda'
    import Vue from 'vue'
    import store from '@/store'
    import ActionRow from '@/components/form/ActionRow'
    import CreateForm from '@/components/campaigns/CreateForm'
    import Navigation from '@/components/products/Navigation'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {

        components: { ActionRow, CreateForm, Navigation },

        async beforeRouteEnter(to, from, next) {

            if (Vue.$auth.isZmuekish) {
                // Alle Auftraggeber laden
                await store.dispatch('companies/loadAllByIsPurchaser')

            } else {
                // Eigenes Unternehmen laden
                await store.dispatch('companies/loadOne', { id: Vue.$auth.companyId })
            }

            next()
        },

        created() {
            // Wenn Benutzer nicht zmuekish, dann Unternehmen des Benutzers als als Auftraggeber setzen
            if (!this.$auth.isZmuekish) {
                this.mutable = R.assoc('company', this.$auth.companyId, this.mutable)
            }
        },

        computed: {

            companyModels() {
                return store.getters['companies/allByIsPurchaser']
            },

        },

        data() {
            return {
                mutable: { }
            }
        },

        methods: {

            cancel() {
                this.$router.push({ name: 'campaigns' })
            },

            async persist() {
                try {
                    // Formular speichern
                    await this.$refs.form.create()

                    // Erfolgsmeldung anzeigen
                    this.$growl.success('Kampagne wurde erstellt')

                    // Weiterleitung zu Übersicht
                    this.$router.push({name: 'campaigns'})

                } catch (e) {

                    // Fehlermeldung anzeigen
                    this.$growl.fatal('Kampagne konnte nicht gespeichert werden', e)
                }

            },

            async submit() {
                if (await this.$refs.form.validate()) {
                    this.persist()
                }
            }


        }

    }

</script>
